<script setup>
import { ref, computed } from 'vue';
import Button from 'dashboard/components-next/button/Button.vue';
import { eventTypeMeta } from '../utils/eventMeta';

const props = defineProps({
  script: { type: Object, required: true },
});
defineEmits(['use']);

const expanded = ref(false);
const meta = computed(() => eventTypeMeta(props.script.eventType));

const preview = computed(() => {
  const b = props.script.body || '';
  return b.length > 200 ? `${b.slice(0, 200)}…` : b;
});
</script>

<template>
  <div class="rounded-xl border border-n-strong/40 bg-n-background p-4 shadow-sm">
    <div class="mb-2 flex items-start justify-between gap-2">
      <div class="flex items-start gap-2">
        <span :class="[meta.color, 'flex size-8 shrink-0 items-center justify-center rounded-md text-white']">
          <span :class="meta.icon" class="size-4" />
        </span>
        <div>
          <p class="text-sm font-bold text-n-slate-12">{{ script.title }}</p>
          <p class="text-[10px] text-n-slate-11">
            {{ meta.label }}
            <span v-if="script.durationMinutes"> · {{ script.durationMinutes }} min</span>
            <span v-if="script.isGlobal"> · template</span>
          </p>
        </div>
      </div>
      <Button variant="ghost" size="sm" icon="i-lucide-copy" title="Copiar" @click="$emit('use', script)">
        Usar
      </Button>
    </div>

    <div v-if="script.tags?.length" class="mb-2 flex flex-wrap gap-1">
      <span
        v-for="t in script.tags"
        :key="t"
        class="rounded bg-n-slate-2 px-1.5 py-0.5 text-[10px] text-n-slate-11"
      >
        {{ t }}
      </span>
    </div>

    <pre
      :class="['whitespace-pre-wrap rounded-md bg-n-slate-2 p-3 font-mono text-[11px] leading-relaxed text-n-slate-12', expanded ? '' : 'max-h-40 overflow-hidden']"
    >{{ expanded ? script.body : preview }}</pre>

    <button
      v-if="script.body?.length > 200"
      type="button"
      class="mt-2 text-[11px] font-semibold text-blue-700 hover:text-blue-800"
      @click="expanded = !expanded"
    >
      {{ expanded ? 'Ver menos' : 'Ver completo' }}
    </button>
  </div>
</template>
